import { getJson, playableUrl } from './storage/s3';
import { getMeetingS3Keys } from './supabase/meetingsRepo';
import type { MeetingMediaDTO, TranscriptSegmentDTO } from '../shared/types';
import { t } from './language';

/**
 * Toplantı açılınca ses ve transkripti S3'ten getirir.
 *
 * Sahiplik kontrolü veritabanında: anahtarlar RLS'li sorguyla okunuyor, yani
 * kullanıcı yalnızca kendi toplantısının anahtarlarına ulaşabiliyor. Ses
 * dosyası indirilmiyor — `<audio>` süreli imzalı adresten doğrudan akıtıyor.
 */
export async function getMeetingMedia(meetingId: unknown): Promise<MeetingMediaDTO> {
  if (typeof meetingId !== 'string' || !meetingId) throw new Error(t('Geçersiz toplantı.', 'Invalid meeting.'));

  const keys = await getMeetingS3Keys(meetingId);
  if (!keys) return { transcript: [] };

  const [audioUrl, transcript] = await Promise.all([
    keys.audioKey ? playableUrl(keys.audioKey) : Promise.resolve(undefined),
    getJson<TranscriptSegmentDTO[]>(keys.transcriptKey).catch((err) => {
      console.error('[meetingMedia] transkript okunamadı:', meetingId, err);
      throw new Error(t('Transkript S3\'ten okunamadı.', 'The transcript could not be read from S3.'));
    }),
  ]);

  return { audioUrl, transcript: Array.isArray(transcript) ? transcript : [] };
}
